import update from 'immutability-helper';
import {CWA_STATUS, CLEAR, ERROR} from '../actions/action-types';

const initialState = {
  status: {status: null, statusRedirectUri: null},
  isError: false,
  locale: 'da',
};

const cwa = (state = initialState, action) => {
  switch (action.type) {
    case CWA_STATUS:
      return update(state, {
        status: {$set: action.response},
        isError: {$set: false},
      });
    case ERROR:
      return update(state, {
        isError: {$set: true},
      });
    case CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default cwa;
